import React from "react";
import classes from "./ModalBackground.module.scss";
import { ModalBackgroundProps } from "components/v2/Modals/ModalBackground/types/ModalBackgroundProps";

const ModalBackground: React.FC<ModalBackgroundProps> = ({
  children,
  isOpen,
  onClose,
}) => {
  const closeModalByBackground = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (isOpen) {
    return (
      <div
        className={classes["modal-background"]}
        id="overlay"
        onClick={closeModalByBackground}
      >
        {children}
      </div>
    );
  } else return null;
};
export default ModalBackground;
